/* eslint-disable no-unused-vars */
import React from 'react';
import StockTable from '../components/StockTable';

const HandpiecePage = ({
  itemMaster = [],
  supplies = [],
  handpieceSearchQuery = '',
  setHandpieceSearchQuery = () => {},
  handpieceFilter = 'all',
  setHandpieceFilter = () => {},
  selectedHandpieceName = null,
  setSelectedHandpieceName = () => {},
  getStatusConfig = () => ({ label: '', bg: '#ccc' }),
  handleTogglePreview = () => {},
  showPreview = {},
  parseImages = () => ({}),
  setExpandedImage = () => {},
  handleUpdateAmount = () => {},
  handleDeleteMaster = () => {},
  startEdit = () => {}
}) => {
  const allHandpieces = itemMaster.filter(masterLot => masterLot.category === 'หัวกรอ');
  const uniqueNames = allHandpieces
    .reduce((acc, curr) => acc.includes(curr.item_name) ? acc : [...acc, curr.item_name], []);

  const handpieceGroups = uniqueNames.map(name => {
    const lots = allHandpieces.filter(masterLot => masterLot.item_name === name);
    const isSetGroup = lots[0]?.is_set || false;
    const usable = lots.reduce((total, masterLot) => {
      const lotAmt = supplies.filter(s => s.master_id === masterLot.id).reduce((sum, s) => sum + (s.item_amount || 0), 0);
      return total + lotAmt;
    }, 0);
    return { name, lots, isSetGroup, usable };
  }).filter(group => {
    if (!handpieceSearchQuery) return true;
    const nameMatches = group.name.toLowerCase().includes(handpieceSearchQuery.toLowerCase());
    const firstLot = group.lots[0];
    const aliasMatches = firstLot && firstLot.aliases && firstLot.aliases.toLowerCase().includes(handpieceSearchQuery.toLowerCase());
    return nameMatches || aliasMatches;
  });

  const setGroups = handpieceGroups.filter(g => g.isSetGroup);
  const singleGroups = handpieceGroups.filter(g => !g.isSetGroup);

  const totalSetsCount = setGroups.length;
  const totalSinglesCount = singleGroups.length;
  const totalUsableCount = handpieceGroups.reduce((sum, g) => sum + g.usable, 0);

  const renderCard = (group) => {
    const { name, lots, isSetGroup, usable } = group;
    const cardClass = isSetGroup ? 'set-card' : 'single-card';
    const firstLot = lots[0];
    const locationText = (firstLot?.cabinet || firstLot?.shelf || firstLot?.row)
      ? `📍 ${firstLot.cabinet ? `ตู้: ${firstLot.cabinet}` : ''} ${firstLot.shelf ? `ชั้น: ${firstLot.shelf}` : ''} ${firstLot.row ? `แถว: ${firstLot.row}` : ''}`
      : '📍 ไม่ระบุพิกัด';

    return (
      <div
        key={name}
        className={`handpiece-card ${cardClass}`}
        style={{ cursor: 'pointer' }}
        onClick={() => setSelectedHandpieceName(name)}
      >
        <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div className="handpiece-card-header-row">
            <div className="handpiece-title-text">
              <span>{isSetGroup ? '📦 ' : '🦷 '} {name}</span>
              <small>ขนาดบรรจุ: {firstLot?.unit_size || '-'}</small>
            </div>
            <span className="handpiece-badge-qty">
              พร้อมใช้: {usable} {firstLot?.unit || 'ชิ้น'}
            </span>
          </div>
          <div className="handpiece-meta-row">
            <span className="handpiece-badge-location">
              {locationText}
            </span>
            <span className="handpiece-img-toggle-btn">
              🔍 ดูรายละเอียด
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="handpiece-dashboard-container">
      <h2 style={{ textAlign: 'center', margin: 0, color: '#ffffff', textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>🦷 คลังหัวกรอ</h2>

      {/* Search Bar */}
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
        <input
          type="text"
          placeholder="🔍 ค้นหาหัวกรอ หรือชื่ออื่นๆ..."
          value={handpieceSearchQuery}
          onChange={(e) => setHandpieceSearchQuery(e.target.value)}
          style={{
            width: '100%',
            maxWidth: '500px',
            padding: '12px 16px',
            borderRadius: '25px',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            background: 'rgba(255, 255, 255, 0.1)',
            color: '#ffffff',
            fontSize: '1em',
            outline: 'none',
            transition: 'all 0.3s'
          }}
          onFocus={(e) => { e.target.style.borderColor = '#1abc9c'; e.target.style.background = 'rgba(255, 255, 255, 0.15)'; }}
          onBlur={(e) => { e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)'; e.target.style.background = 'rgba(255, 255, 255, 0.1)'; }}
        />
      </div>

      {/* statistics cards row */}
      <div className="handpiece-stats-row">
        <div className="handpiece-stat-card">
          <span className="handpiece-stat-label">📦 ชุดหัวกรอทั้งหมด</span>
          <span className="handpiece-stat-value">
            {totalSetsCount} <small>ชุด</small>
          </span>
        </div>
        <div className="handpiece-stat-card">
          <span className="handpiece-stat-label">🦷 หัวกรอเดี่ยวทั้งหมด</span>
          <span className="handpiece-stat-value">
            {totalSinglesCount} <small>รายการ</small>
          </span>
        </div>
        <div className="handpiece-stat-card">
          <span className="handpiece-stat-label">✅ จำนวนพร้อมใช้ทั้งหมด</span>
          <span className="handpiece-stat-value" style={{ color: '#2ecc71' }}>
            {totalUsableCount} <small>ชิ้น</small>
          </span>
        </div>
      </div>

      {/* Segmented controls / Tabs switcher */}
      <div className="handpiece-tabs-container">
        <button
          className={`handpiece-tab-btn tab-all ${handpieceFilter === 'all' ? 'active' : ''}`}
          onClick={() => setHandpieceFilter('all')}
        >
          🗂️ ทั้งหมด ({handpieceGroups.length})
        </button>
        <button
          className={`handpiece-tab-btn tab-sets ${handpieceFilter === 'sets' ? 'active' : ''}`}
          onClick={() => setHandpieceFilter('sets')}
        >
          📦 ชุดหัวกรอ ({setGroups.length})
        </button>
        <button
          className={`handpiece-tab-btn tab-singles ${handpieceFilter === 'singles' ? 'active' : ''}`}
          onClick={() => setHandpieceFilter('singles')}
        >
          🦷 หัวกรอเดี่ยว ({singleGroups.length})
        </button>
      </div>

      {/* Sets Section */}
      {(handpieceFilter === 'all' || handpieceFilter === 'sets') && (
        <div className="handpiece-section">
          <div className="handpiece-section-header">
            <h3 className="handpiece-section-title">📦 รายการชุดหัวกรอ ({setGroups.length} ชุด)</h3>
          </div>
          {setGroups.length > 0 ? (
            <div className="handpiece-grid">
              {setGroups.map(group => renderCard(group))}
            </div>
          ) : (
            <div className="handpiece-empty-state">
              <span>{handpieceSearchQuery ? '🔍 ไม่พบชุดหัวกรอที่ตรงตามคำค้นหา' : 'ไม่มีชุดหัวกรอในระบบ'}</span>
            </div>
          )}
        </div>
      )}

      {/* Singles Section */}
      {(handpieceFilter === 'all' || handpieceFilter === 'singles') && (
        <div className="handpiece-section">
          <div className="handpiece-section-header">
            <h3 className="handpiece-section-title">🦷 รายการหัวกรอเดี่ยว ({singleGroups.length} รายการ)</h3>
          </div>
          {singleGroups.length > 0 ? (
            <div className="handpiece-grid">
              {singleGroups.map(group => renderCard(group))}
            </div>
          ) : (
            <div className="handpiece-empty-state">
              <span>{handpieceSearchQuery ? '🔍 ไม่พบหัวกรอเดี่ยวที่ตรงตามคำค้นหา' : 'ไม่มีหัวกรอเดี่ยวในระบบ'}</span>
            </div>
          )}
        </div>
      )}

      {/* Modal popup details */}
      {selectedHandpieceName && (() => {
        const group = handpieceGroups.find(g => g.name === selectedHandpieceName);
        if (!group) return null;
        const { name, lots, isSetGroup, usable } = group;
        const firstLot = lots[0];
        const locationText = (firstLot?.cabinet || firstLot?.shelf || firstLot?.row)
          ? `ตู้: ${firstLot.cabinet || '-'} | ชั้น: ${firstLot.shelf || '-'} | แถว: ${firstLot.row || '-'}`
          : 'ไม่ระบุพิกัด';

        return (
          <div
            className="sterile-modal-overlay"
            onClick={() => setSelectedHandpieceName(null)}
          >
            <div
              className="sterile-modal-content"
              style={{
                maxWidth: '650px',
                width: '95%',
                background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
                color: '#ffffff',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                boxShadow: '0 25px 60px rgba(0,0,0,0.6)',
                padding: 0,
                borderRadius: '24px',
                overflow: 'hidden'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div style={{
                padding: '20px 24px',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: 'rgba(0,0,0,0.2)'
              }}>
                <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px', color: isSetGroup ? '#f48fb1' : '#81d4fa' }}>
                  <span>{isSetGroup ? '📦' : '🦷'}</span>
                  <span style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{name}</span>
                </h3>
                <button
                  onClick={() => setSelectedHandpieceName(null)}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: 'none',
                    color: '#ffffff',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                  onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
                >
                  ✕
                </button>
              </div>

              {/* Modal Body */}
              <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px', maxHeight: '80vh', overflowY: 'auto' }}>
                {/* Quick Info & Stats Badges */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div style={{ background: 'rgba(255,255,255,0.04)', padding: '12px 16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <div style={{ fontSize: '0.8em', color: 'rgba(255,255,255,0.5)', marginBottom: '4px' }}>📍 พิกัดการจัดเก็บ</div>
                    <div style={{ fontWeight: '600', fontSize: '0.95em' }}>{locationText}</div>
                  </div>
                  <div style={{ background: 'rgba(255,255,255,0.04)', padding: '12px 16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <div style={{ fontSize: '0.8em', color: 'rgba(255,255,255,0.5)', marginBottom: '4px' }}>สถานะคลัง</div>
                      <div style={{ fontWeight: '700', fontSize: '1.1em', color: isSetGroup ? '#f48fb1' : '#81d4fa' }}>พร้อมใช้: {usable} {firstLot?.unit || 'ชิ้น'}</div>
                    </div>
                    <span style={{ fontSize: '0.8em', color: 'rgba(255,255,255,0.4)' }}>({firstLot?.unit_size || '-'})</span>
                  </div>
                </div>

                {/* Photo Previews */}
                {firstLot?.image_url && (() => {
                  const { full, zoom, other, document: doc } = parseImages(firstLot.image_url);
                  const images = [
                    { label: '📸 รูปเต็ม', url: full, color: '#1abc9c' },
                    { label: '🔍 รูปซูม', url: zoom, color: '#3498db' },
                    { label: '🖼️ รูปอื่นๆ', url: other, color: '#9b59b6' },
                    { label: '📄 เอกสาร', url: doc, color: '#f1c40f' }
                  ].filter(img => img.url);

                  if (images.length === 0) return null;

                  return (
                    <div style={{
                      background: 'rgba(0,0,0,0.2)',
                      borderRadius: '16px',
                      padding: '16px',
                      border: '1px solid rgba(255, 255, 255, 0.08)'
                    }}>
                      <h4 style={{ margin: '0 0 12px 0', fontSize: '0.9em', color: 'rgba(255,255,255,0.6)', fontWeight: 'bold' }}>📸 รูปภาพและเอกสารอ้างอิง</h4>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: images.length === 1 ? '1fr' : 'repeat(auto-fit, minmax(130px, 1fr))',
                        gap: '15px'
                      }}>
                        {images.map((img, i) => (
                          <div key={i} style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            <span style={{ fontSize: '0.8em', color: 'rgba(255,255,255,0.5)', fontWeight: '600' }}>{img.label}</span>
                            <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setExpandedImage(img.url)}>
                              <img src={img.url} alt={img.label} style={{ width: '100%', height: '120px', borderRadius: '8px', border: `1px solid ${img.color}`, objectFit: 'contain', background: 'rgba(0,0,0,0.3)' }} />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })()}

                {/* Components List for Set */}
                {isSetGroup && firstLot?.components && firstLot.components.length > 0 && (
                  <div style={{
                    background: 'rgba(244, 143, 177, 0.05)',
                    borderRadius: '16px',
                    padding: '16px',
                    border: '1px solid rgba(244, 143, 177, 0.15)'
                  }}>
                    <h4 style={{ margin: '0 0 12px 0', fontSize: '0.9em', color: '#f48fb1', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      📦 อุปกรณ์ประกอบในชุด ({firstLot.components.length} รายการ):
                    </h4>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(95px, 1fr))', gap: '10px' }}>
                      {firstLot.components.map(compId => {
                        const compItem = itemMaster.find(i => i.id === compId);
                        if (!compItem) return null;
                        return (
                          <div key={compId} style={{ border: '1px solid rgba(244, 143, 177, 0.2)', borderRadius: '10px', padding: '8px', textAlign: 'center', background: '#ffffff', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                            {compItem.image_url ? (
                              <img src={compItem.image_url} alt={compItem.item_name} style={{ width: '45px', height: '45px', objectFit: 'contain', borderRadius: '6px', margin: '0 auto 6px', display: 'block', border: '1px solid rgba(0,0,0,0.05)' }} />
                            ) : (
                              <div style={{ width: '45px', height: '45px', background: '#f3f4f6', borderRadius: '6px', margin: '0 auto 6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.6em', color: '#9ca3af', border: '1px solid #e5e7eb' }}>ไม่มีรูป</div>
                            )}
                            <div style={{ fontSize: '0.7em', fontWeight: '700', color: '#c2185b', lineHeight: '1.2', wordWrap: 'break-word', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', height: '2.4em' }} title={compItem.item_name}>
                              {compItem.item_name}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Stock Table */}
                <div style={{ background: '#ffffff', borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexDirection: 'column', color: '#1e293b' }}>
                  <div style={{ padding: '12px 16px', background: '#f8f9fa', borderBottom: '1px solid #e2e8f0', color: '#334155', fontWeight: 'bold', fontSize: '0.88em' }}>
                    📋 รายการล็อตสิ่งของในระบบ
                  </div>
                  <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                    <StockTable
                      lots={lots}
                      supplies={supplies}
                      category={firstLot?.category}
                      onUpdate={handleUpdateAmount}
                      onDelete={handleDeleteMaster}
                      onEditLot={(lot) => {
                        setSelectedHandpieceName(null);
                        startEdit(lot);
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Modal Footer */}
              <div style={{
                padding: '16px 24px',
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                display: 'flex',
                justifyContent: 'flex-end',
                background: 'rgba(0,0,0,0.2)'
              }}>
                <button
                  onClick={() => setSelectedHandpieceName(null)}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '10px',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    background: 'rgba(255, 255, 255, 0.08)',
                    color: '#ffffff',
                    fontWeight: '600',
                    cursor: 'pointer',
                    fontSize: '0.9em',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.15)'}
                  onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.08)'}
                >
                  ปิดหน้าต่าง
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default HandpiecePage;
